var map = {
	"./nav-list.de-CH.json": 1109,
	"./nav-list.de-DE.json": 1110,
	"./nav-list.en-CA.json": 1111,
	"./nav-list.en-GB.json": 1112,
	"./nav-list.en-IN.json": 1113,
	"./nav-list.en-ME.json": 1114,
	"./nav-list.en-US.json": 1115,
	"./nav-list.es-EM.json": 1116,
	"./nav-list.es-ES.json": 1117,
	"./nav-list.fr-BE.json": 1118,
	"./nav-list.fr-CA.json": 1119,
	"./nav-list.fr-CH.json": 1120,
	"./nav-list.nl-BE.json": 1121,
	"./nav-list.nl-NL.json": 1122,
	"./nav-list.pl-PL.json": 1123,
	"./nav-list.pt-BR.json": 1124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1108;